import InitializerContainer from './initializer_container';

const Initializer = InitializerContainer;

export default Initializer;
